<div class="keywords-dialog">
  <app-modal-header-common title="Select Keywords" [dialogRef]="dialogRef"></app-modal-header-common>

  <div class="keywords-content">
    <form [formGroup]="keywordForm" class="two-pane">
      <!-- Left Pane -->
      <div class="pane left-pane">
        <p class="fw-bold mb-2">Available Keywords</p>

        <div class="add-keyword-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Search or Add keyword</mat-label>
            <input
              matInput
              formControlName="keywords"
              (keyup.enter)="addNewKeyword()"
              placeholder="Search or Create new"
              [matAutocomplete]="autoCreateNew"
            />
            <mat-autocomplete
              #autoCreateNew="matAutocomplete"
              (optionSelected)="addNewKeyword()"
            >
              <mat-option
                *ngIf="
                  (filteredKeywords | async)?.length === 0 &&
                  keywordForm.get('keywords')?.value?.trim()
                "
                [value]="keywordForm.get('keywords')?.value"
                style="font-size: 0.85rem;"
              >
                Create New: "{{ keywordForm.get('keywords')?.value }}"
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="pane-scroll">
          <mat-chip-list>
            <mat-chip
              *ngFor="let keyword of filteredKeywords | async"
              selectable="false"
              removable="false"
              class="keyword-chip"
            >
              {{ keyword }}
              <button
                mat-icon-button
                (click)="toggleKeyword(keyword)"
                class="chip-action add"
              >
                <mat-icon>add</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>

      <div class="pane right-pane">
        <p class="fw-bold mb-2">Selected Keywords</p>

        <div *ngIf="selectedKeywords.length === 0" class="empty-text">
          No keywords selected
        </div>

        <div class="pane-scroll">
          <mat-chip-list>
            <mat-chip
              *ngFor="let keyword of selectedKeywords"
              selectable="false"
              removable="false"
              class="keyword-chip"
            >
              {{ keyword }}
              <button
                mat-icon-button
                (click)="toggleKeyword(keyword)"
                class="chip-action remove"
              >
                <mat-icon>remove</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
    </form>
  </div>

  <div class="keywords-footer d-flex justify-content-end">
    <button
      (click)="closeDialog()"
      mat-button
      mat-dialog-close
      color="primary"
      class="mx-1"
    >
      Close
    </button>
    <button
      mat-raised-button
      color="primary"
      class="templ-btn"
      (click)="saveKeywords()"
    >
      Save
    </button>
  </div>
</div>